// extracted by css-extract-rspack-plugin
export default {"input":"input-gT4Q_w text-body-base"};